// import styles from "./FormSection.module.css";
// import { useState } from "react";

// export default function FormSection() {
//   const [popupOpen, setPopupOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     car: "",
//     phone: "",
//     name: "",
//   });

//   // срабатывает каждый раз при вводе в поле данных
//   //e - объект события, автоматически передающийся при изменении формы.
//   //e.target - конкретный DOM элемент формы, который вызвал событие
//   // name - атрибут поля ввода (car, name, phone)
//   // value - текущее значение
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value, //Обновление поля в объекте formData по ключ:значение
//     });
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault(); // Останавливаем отправку формы

//     try {
//       const response = await fetch("/api/sendToTelegram.php", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });

//       if (response.ok) {
//         setPopupOpen(true); // Показываем попап
//         setFormData({
//           car: "",
//           phone: "",
//           name: "",
//         })
//       } else {
//         console.error("Ошибка при отправке данных");
//       }
//     } catch (error) {
//       console.error("Ошибка:", error);
//     }
//   };

//   const closePopup = () => {
//     setPopupOpen(false);
//   };

//   return (
//     <div className={styles.container}>
//       <form className={styles.form} onSubmit={handleSubmit}>
//         <h2 className={styles.form__title}>
//           Продай авто за <span className={styles.form__title_span}>ЧАС!</span>
//         </h2>
//         <div className={styles.form__inputsWrapper}>
//           <label className={styles.form__label} htmlFor="car">
//             Марка, модель, год выпуска
//           </label>
//           <input
//             className={styles.form__input}
//             type="text"
//             name="car"
//             minLength="3"
//             required
//             placeholder="Ford Econoline 1997"
//             value={formData.car}
//             onChange={handleChange}
//           />
//           <label className={styles.form__label} htmlFor="phone">
//             Ваш номер
//           </label>
//           <input
//             className={styles.form__input}
//             type="tel"
//             name="phone"
//             minLength="5"
//             required
//             placeholder="8-930-550-35-35"
//             value={formData.phone}
//             onChange={handleChange}
//           />
//           <label className={styles.form__label} htmlFor="name">
//             Ваше имя
//           </label>
//           <input
//             className={styles.form__input}
//             type="text"
//             name="name"
//             placeholder="Ваше имя"
//             value={formData.name}
//             onChange={handleChange}
//           />
//         </div>
//         <button className={styles.button} type="submit">
//           <p className={styles.button__text}>Продать сейчас</p>
//         </button>
//       </form>
//       <div className={popupOpen ? styles.popupOpen : styles.popupClose}>
//         <div className={styles.popup}>
//           <p className={styles.popup__title}>Спасибо!</p>
//           <p className={styles.popup__text}>
//             Мы уже получили Вашу заявку и ответим Вам в течение 15 минут.
//           </p>
//           <p className={styles.popup__text}>
//             Не хотите ждать? Позвоните нам: <br />
//             8-993-983-89-98
//           </p>
//           <button className={styles.popup__button} onClick={closePopup}>
//             Отлично!
//           </button>
//         </div>
//       </div>
//       <p className={styles.slogan}>Ваше авто — наша забота. Питер мобиль.</p>
//     </div>
//   );
// }
import styles from "./FormSection.module.css";
import { useState } from "react";

export default function FormSection() {
  const [popupOpen, setPopupOpen] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [formData, setFormData] = useState({
    car: "",
    phone: "",
    name: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.car || !formData.phone) {
      setShowErrors(true);
      return;
    }

    try {
      const response = await fetch("/api/sendToTelegram.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setPopupOpen(true);
        setFormData({ car: "", phone: "", name: "" });
        setShowErrors(false);
      } else {
        console.error("Ошибка при отправке данных");
      }
    } catch (error) {
      console.error("Ошибка:", error);
    }
  };

  const closePopup = () => {
    setPopupOpen(false);
  };

  const isInvalid = !formData.car || !formData.phone;
  const isPhoneInvalid = showErrors && formData.phone.length < 5 ;
  const isCarInvalid = showErrors && formData.car.length < 3 ;

  return (
    <div className={styles.container}>
      <form className={styles.form} onSubmit={handleSubmit}>
        <h2 className={styles.form__title}>
          Продай авто за <span className={styles.form__title_span}>ЧАС!</span>
        </h2>

        <div className={styles.form__inputsWrapper}>
          <label className={styles.form__label} htmlFor="car">
            Марка, модель, год выпуска
            <p className={`${styles.error} ${isCarInvalid ? styles.error_active : ""}`}>
              (минимум 3 сим.)
            </p>
          </label>
          <input
            className={styles.form__input}
            type="text"
            name="car"
            minLength="3"
            placeholder="Ford Econoline 1997"
            value={formData.car}
            onChange={handleChange}
          />


          <label className={styles.form__label} htmlFor="phone">
            Ваш номер 
            <p className={`${styles.error} ${isPhoneInvalid ? styles.error_active : ""}`}>
              (минимум 5 сим.)
            </p>
          </label>
          <input
            className={styles.form__input}
            type="tel"
            name="phone"
            minLength="5"
            placeholder="8-930-550-35-35"
            value={formData.phone}
            onChange={handleChange}
          />

          <label className={styles.form__label} htmlFor="name">
            Ваше имя
          </label>
          <input
            className={styles.form__input}
            type="text"
            name="name"
            placeholder="Ваше имя"
            value={formData.name}
            onChange={handleChange}
          />
        </div>

        {/* Обертка для клика по disabled-кнопке */}
        <div style={{ position: 'relative' }}>
          <button
            type="submit"
            disabled={isInvalid}
            className={styles.button}
          >
            Продать сейчас
          </button>
          {isInvalid && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
              onClick={() => setShowErrors(true)}
            />
          )}
        </div>

      </form>

      <div className={popupOpen ? styles.popupOpen : styles.popupClose}>
        <div className={styles.popup}>
          <p className={styles.popup__title}>Спасибо!</p>
          <p className={styles.popup__text}>
            Мы уже получили Вашу заявку и ответим Вам в течение 15 минут.
          </p>
          <p className={styles.popup__text}>
            Не хотите ждать? Позвоните нам: <br />
            8-993-983-89-98
          </p>
          <button className={styles.popup__button} onClick={closePopup}>
            Отлично!
          </button>
        </div>
      </div>

      <p className={styles.slogan}>Ваше авто — наша забота. Питер мобиль.</p>
    </div>
  );
}
